import { render, staticRenderFns } from "./o-resource-list.vue?vue&type=template&id=146465be&scoped=true&"
import script from "./o-resource-list.vue?vue&type=script&lang=js&"
export * from "./o-resource-list.vue?vue&type=script&lang=js&"
import style0 from "./o-resource-list.vue?vue&type=style&index=0&id=146465be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146465be",
  null
  
)

export default component.exports